// extracted by mini-css-extract-plugin
module.exports = {"message":"popup-module--message--15igs","message_content":"popup-module--message_content--45d3p"};